/**
 * Converts a `datetime-local` value ("2026-09-05T14:00") into an absolute ISO
 * instant, reading it in the event's own timezone rather than the organizer's
 * browser timezone. The Scanner capture cutoff is derived from this value, so
 * an organizer travelling or working remotely must not shift the event window.
 */
export function localInputToIso(naive: string, timeZone: string): string {
  const withSeconds = naive.length === 16 ? `${naive}:00` : naive;
  const asIfUtc = new Date(`${withSeconds}Z`);
  if (Number.isNaN(asIfUtc.getTime())) {
    throw new Error(`Invalid local datetime: ${naive}`);
  }

  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(asIfUtc);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "00";
  const shown = Date.parse(
    `${value("year")}-${value("month")}-${value("day")}T${value("hour")}:${value("minute")}:${value("second")}Z`,
  );

  const offsetMs = shown - asIfUtc.getTime();
  return new Date(asIfUtc.getTime() - offsetMs).toISOString();
}

export function canRegisterParticipant(state: string): boolean {
  return state === "checkin" || state === "active";
}

export function canSubmitEndStats(state: string): boolean {
  return (
    state === "checkin" ||
    state === "active" ||
    state === "checkout" ||
    state === "review"
  );
}
